import {
    SET_KEY,
} from '../constants/DashboardActionTypes';

export const setKey = payload => {
    return {
        type: SET_KEY,
        payload,
    };
};